import InfoOutline from "@mui/icons-material/InfoOutline";
import { Alert, Box, Button } from "@mui/material";
import { useLexicalContext } from "../lexical-context";

import type { FC } from "react";

export const SmsNonGsmBanner: FC = () => {
  const {
    text: { nonGSMCharacters, nonGsmHighlightVisible, setNonGsmHighlightVisible },
  } = useLexicalContext();

  if (nonGSMCharacters.length === 0) return null;

  const uniqueChars = [...new Set(nonGSMCharacters)];
  const displayChars = uniqueChars.map((c) => `"${c}"`).join(" ");

  return (
    <Box sx={{ mb: 1 }}>
      <Alert
        icon={<InfoOutline />}
        severity="info"
        sx={{ alignItems: "center", "& .MuiAlert-action": { pt: 0 } }}
        action={
          <Button
            color="inherit"
            size="small"
            onClick={() => setNonGsmHighlightVisible(!nonGsmHighlightVisible)}
            data-analytics-id="sms-non-gsm-banner-toggle"
          >
            {nonGsmHighlightVisible ? "Hide" : "Show"}
          </Button>
        }
      >
        Your message contains special characters ({displayChars}), which use more of your character
        count than usual.
      </Alert>
    </Box>
  );
};
